import {
    createStore, applyMiddleware, combineReducers,
} from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import { normalize } from 'normalizr';
import { getMetaDatabase } from 'utils/store';
import reducers, { initialState } from './reducers';
import { initialState as databaseInitialState } from './reducers/database.reducer';
import {
    destinationSchema, hotelRoomSchema, hotelSchema, regionSchema,
} from './schemas/database.schema';

/*
let store = null;
const composeEnhancers = compose;

const middlewares = [thunkMiddleware];
let enhancers = [applyMiddleware(...middlewares)];

const finalReducers = combineReducers({
    app: reducers,
});

if (process.env.NODE_ENV === 'development')
{
    enhancers.push(composeWithDevToolsDevelopmentOnly());
    store = createStore(finalReducers, {}, composeEnhancers(...enhancers));
}
else
{
    store = createStore(finalReducers, {}, composeEnhancers(...enhancers));
}

const finalStore = store;
export default finalStore;
*/

export const finalStore = (source) =>
{
    const _initialState = { app: { ...initialState, database: { ...databaseInitialState }, metaDatabase: {} } };

    const dispatchToDatabase = (data, schema) =>
    {
        const n = normalize(data, schema);
        _initialState.app = {
            ..._initialState,
            database: { ..._initialState.app.database, ...n.entities },
            metaDatabase: { ..._initialState.app.metaDatabase, ...getMetaDatabase(n.entities) },
        };
    };

    Object.keys(source).forEach((key) =>
    {
        switch (key)
        {
            case 'hotels':
                dispatchToDatabase(source[key], [hotelSchema]);
                break;
            case 'hotel':
                dispatchToDatabase(source[key], hotelSchema);
                break;
            case 'hotel_room':
                dispatchToDatabase(source[key], hotelRoomSchema);
                break;
            case 'destinations':
                dispatchToDatabase(source[key], [destinationSchema]);
                break;
            case 'destination':
                dispatchToDatabase(source[key], destinationSchema);
                break;
            case 'regions':
                dispatchToDatabase(source[key], [regionSchema]);
                break;
        }
    });

    const finalReducers = combineReducers({
        app: reducers,
    });

    const middleware = [thunk];

    return createStore(
        finalReducers,
        _initialState,
        composeWithDevTools(
            applyMiddleware(...middleware),
        ),
    );
};
